import React from 'react';
import { useLocation } from 'react-router-dom';

const RegistrationSuccess: React.FC = () => {
  const location = useLocation();
  const camperName = (location.state as any)?.camperName || '';
  const year = (location.state as any)?.year || '';
  const isUpdate = (location.state as any)?.isUpdate || false;

  return (
    <div style={{
      minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem'
    }}>
      <div style={{
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center',
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: '3rem 2rem',
        boxShadow: '0 2px 12px rgba(0,0,0,0.1)'
      }}
      className="registration-success-card"
      >
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>&#10003;</div>
        <h1 style={{ color: '#2e7d32', marginBottom: '1rem' }}>
          {isUpdate ? 'Registration Updated!' : 'Registration Submitted!'}
        </h1>
        {camperName && (
          <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '1.5rem' }}>
            {isUpdate
              ? <>Thank you, <strong>{camperName}</strong>. Your registration{year ? ` for Berwick Camp ${year}` : ''} has been updated.</>
              : <>Thank you, <strong>{camperName}</strong>, for registering{year ? ` for Berwick Camp ${year}` : ''}.</>
            }
          </p>
        )}
        <div style={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffc107',
          borderRadius: '8px',
          padding: '1.25rem',
          marginBottom: '1.5rem',
          textAlign: 'left'
        }}>
          <h3 style={{ color: '#856404', marginTop: 0, marginBottom: '0.5rem' }}>Important Information</h3>
          <p style={{ margin: '0.5rem 0', color: '#856404' }}>
            This is <strong>not</strong> a confirmation of your accommodation. The registrar will review your
            request and assign accommodations in <strong>May</strong>.
          </p>
          <p style={{ margin: '0.5rem 0', color: '#856404' }}>
            You will receive an invoice by email once your accommodation is confirmed.
          </p>
        </div>
        <div style={{
          backgroundColor: '#e7f3ff',
          border: '1px solid #4299e1',
          borderRadius: '8px',
          padding: '1.25rem',
          marginBottom: '1.5rem',
          textAlign: 'left'
        }}>
          <h3 style={{ color: '#2c5aa0', marginTop: 0, marginBottom: '0.5rem' }}>What Happens Next?</h3>
          <p style={{ margin: '0.5rem 0', color: '#2c5aa0' }}>
            A confirmation email has been sent to your email address. Please check your spam folder if you don't see it.
          </p>
        </div>
        <p style={{ fontSize: '0.9rem', color: '#666' }}>
          Questions? Email us at{' '}
          <a href="mailto:registraruccma@gmail.com" style={{ color: '#4299e1' }}>
            registraruccma@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
